export const collectNames = (name, type, data, memberNumber) => {
  if (type === "TEAM_LEADER") {
    return {
      type:
        name === "FIRST_NAME"
          ? "TEAM_LEADER_FIRST_NAME"
          : "TEAM_LEADER_LAST_NAME",
      payload: data
    }
  } else {
    return {
      type:
        name === "FIRST_NAME"
          ? `TEAM_MEMBER_${memberNumber}_FIRST_NAME`
          : `TEAM_MEMBER_${memberNumber}_LAST_NAME`,
      payload: data,
      index: memberNumber
    }
  }
}
